/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { RatingReview, SecondaryRatings } from '@product-reviews/data-access';

@Component({
    selector: 'product-reviews-secondary-rating-container',
    templateUrl: './review-secondary-rating-container.component.html',
    styleUrls: ['./review-secondary-rating-container.component.scss'],
    standalone: false
})
export class ReviewSecondaryRatingContainerComponent implements OnInit {
	@Input() secondaryRatings: SecondaryRatings;
	@Input() secondaryRatingsOrder: string[] = [];
	@Input() isHighlight = false;
	@Input() isIndividualReview = true;

	ratings: RatingReview[] = [];

	ngOnInit(): void {
		if (this.isIndividualReview) {
			this.ratings = this.mapReviews();
		}
	}

	private mapReviews(): RatingReview[] {
		const ratingReviews = this.secondaryRatingsOrder?.map((order: string) => {
			const review = this.secondaryRatings[order];
			return {
				minValue: 0,
				maxValue: review.ValueRange,
				currentValue: review.Value,
				value: review.Value,
				valueRange: review.ValueRange,
				averageRating: review.Value,
				type: review.DisplayType,
				label: review.Label,
				minLabel: review.MinLabel,
				maxLabel: review.MaxLabel,
				middleLabel: review.ValueLabel
			};
		});
		return ratingReviews?.slice().sort(({ type }) => (type === 'SLIDER' ? -1 : 1));
	}
}
